import OpenLinkInTab from "./OpenLinkInTab";

export default {
  install(Vue, options) {
    Vue.prototype.$openLinkInTabOptions = Vue.observable({
      text: "Por favor verifique se o bloqueador de popup do seu navegador está ativo.",
      urlText: "Clique aqui para abrir novamente.",
      url: "",
      open: false,
    });
    Vue.component("OpenLinkInTab", OpenLinkInTab);
    Vue.prototype.$openLinkInTab = function (url, urlText, text) {
      this.$openLinkInTabOptions.text = text ?? this.$openLinkInTabOptions.text;
      this.$openLinkInTabOptions.urlText =
        urlText ?? this.$openLinkInTabOptions.urlText;
      this.$openLinkInTabOptions.url = url;
      this.$openLinkInTabOptions.open = true;
    };
  },
};
